/**
 * Grundbuchmeldung API
 * API for Grundbuchmeldung Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MeldungsEmpfaengerId } from './meldungsEmpfaengerId';
import { TagebuchNummerSearchRequest } from './tagebuchNummerSearchRequest';


export interface Ech0134GrundbuchmeldungSearchRequest { 
    empfaengerId?: MeldungsEmpfaengerId;
    tagebuchNummer?: TagebuchNummerSearchRequest;
    status?: Ech0134GrundbuchmeldungSearchRequest.StatusEnum;
    datumVersandVon?: string;
    datumVersandBis?: string;
    grundbuchmeldungSort?: Ech0134GrundbuchmeldungSearchRequest.GrundbuchmeldungSortEnum;
    sortDirection?: Ech0134GrundbuchmeldungSearchRequest.SortDirectionEnum;
    offset?: number;
    limit?: number;
}
export namespace Ech0134GrundbuchmeldungSearchRequest {
    export type StatusEnum = 'NICHT_ERSTELLT' | 'ERSTELLT' | 'FEHLERHAFT_ERSTELLT' | 'FEHLERHAFT_GESENDET' | 'GESENDET';
    export const StatusEnum = {
        NICHTERSTELLT: 'NICHT_ERSTELLT' as StatusEnum,
        ERSTELLT: 'ERSTELLT' as StatusEnum,
        FEHLERHAFTERSTELLT: 'FEHLERHAFT_ERSTELLT' as StatusEnum,
        FEHLERHAFTGESENDET: 'FEHLERHAFT_GESENDET' as StatusEnum,
        GESENDET: 'GESENDET' as StatusEnum
    };
    export type GrundbuchmeldungSortEnum = 'GESCHAEFTS_NUMMER' | 'EMPFAENGER_BEZEICHNUNG' | 'EMPFAENGER_SEDEX_ID' | 'MELDUNGS_STATUS' | 'DATUM_VERSAND';
    export const GrundbuchmeldungSortEnum = {
        GESCHAEFTSNUMMER: 'GESCHAEFTS_NUMMER' as GrundbuchmeldungSortEnum,
        EMPFAENGERBEZEICHNUNG: 'EMPFAENGER_BEZEICHNUNG' as GrundbuchmeldungSortEnum,
        EMPFAENGERSEDEXID: 'EMPFAENGER_SEDEX_ID' as GrundbuchmeldungSortEnum,
        MELDUNGSSTATUS: 'MELDUNGS_STATUS' as GrundbuchmeldungSortEnum,
        DATUMVERSAND: 'DATUM_VERSAND' as GrundbuchmeldungSortEnum
    };
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
}


